module.exports = __webpack_public_path__ + "media/images/partners/LG-8af54cceeaad5bc5784df1d60268d3bc.png";